"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var messages = {
  hu: {
    sprinxFormsValidation: {
      required: 'szükséges !',
      string: 'Must be a string!',
      stringEmpty: 'Biztos nem üres!',
      stringMin: 'A hosszúságnak nagyobbnak vagy egyenlõnek kell lennie, mint az elõzetesen elvárt {expected} hosszúság !',
      stringMax: 'A hosszúságnak kisebbnek vagy egyenlõnek kell lennie, mint az elõzetesen elvért  {expected} hosszúság !',
      stringLength: 'A hosszúságnak meg kell egyeznie az elõzetesen elvárt {expected} hosszúsággal!',
      stringPattern: 'Nem felel meg az elvárt mintának !',
      stringContains: "Tartalmaznia kell a '{expected}' szöveget !",
      stringEnum: 'Nem egyezik a megengedett értékekkel !',
      number: 'Egy számnak kell lennie !',
      numberMin: 'Nagyobb vagy egyenlõnek kell lennie mint {expected}!',
      numberMax: 'Kisebb vagy egyenlõnek kell lennie mint {expected}!',
      numberEqual: 'Egyenlõnek kell lennie a {expected}-vel !',
      numberNotEqual: "Nem lehet egyenlõ a {expected}-vel !",
      numberInteger: 'Egész számnak kell lennie !',
      numberPositive: 'Pozitív számnak kell lennie !',
      numberNegative: 'Negatív számnak kell lennie !',
      array: 'Egy sornak kell lennie !',
      arrayEmpty: 'Nem lehet üres sor !',
      arrayMin: 'Legalább {expected, plural, one {1 item} other {{expected} items}} szükséges .',
      arrayMax: "Nem tartalmazhat többet, mint  {expected, plural, one {1 item} other {{expected} items}}.",
      arrayLength: 'Tartalmaznia kell {expected, plural, one {1 item} other {{expected} items}}!',
      arrayContains: " Tartalmazina kell a  '{expected}' terméket !",
      arrayEnum: "Az érték  '{expected}' nem felel meg a megengedett értékek egyikének sem !",
      boolean: 'Logikai értéknek kell lennie !',
      function: 'Funkciónak kell lennie !',
      date: 'Dátumnak kell lennie !',
      dateMin: 'Nagyobbnak vagy egyenlõnek kell lennie mint {expected}!',
      dateMax: 'Kisebbnek vagy egyenlõnek kell lennie mint {expected}!',
      forbidden: 'Tilos !',
      email: 'Érvénytelen e-mail !',
      url: 'Érvénytelen URL!',
      object: 'Tárgynak kell lennie !',
      arrayReducedEquals: "A csökkentett érték nem egyezik {expected}!",
      phoneNumber: "Érvényes telefonszám kell nemzetközi formátumban '+XXX XXX XXX XXX'!",
      dateGt: 'A dátumnak késõbbinek kell lennie mint {expected}!',
      dateGte: 'A dátumnak késõbbinekvagy ugyanannak kell lennie mint {expected}!',
      dateLt: 'A dátumnak korábbinak kell lennie mint {expected}!',
      dateLte: 'A dátumnak korábbinak, vagy ugyanannak kell lennie mint {expected}!'
    }
  }
};
var _default = messages;
exports.default = _default;